import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';

@Component({
    selector: 'app-condition-group',
    templateUrl: './condition-group.component.html',
    styleUrls: ['./condition-group.component.scss'],
    standalone: false
})
export class ConditionGroupComponent implements OnInit {
    @Input() form!: FormGroup;
    @Input() modelProperties: any[] = [];
    @Input() canRemove: boolean = true;
    @Input() mode: number = 1;
    @Output() remove = new EventEmitter<void>();

    get isHalfWidth(): boolean {
        return this.mode === 2;
    }

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
        if (!this.form) {
            this.form = this.createConditionGroupForm();
        }
    }

    get conditions() {
        return this.form.get('Conditions') as FormArray;
    }

    get childGroups() {
        return this.form.get('ChildGroups') as FormArray;
    }

    createConditionGroupForm(): FormGroup {
        return this.fb.group({
            Id: [null],
            RequireAllConditions: [false],
            Conditions: this.fb.array([]),
            ChildGroups: this.fb.array([])
        });
    }

    createConditionForm(): FormGroup {
        return this.fb.group({
            Id: [null],
            ClassName: [{
                value: 'SignConfigurationDisplayRuleThresholdCondition',
                disabled: false
            }],
            TargetThresholdProperty: [''],
            TargetThresholdOperator: ['='],
            Value: [''],
            Time: [null],
            Operator: ['='],
            ActiveMonday: [false],
            ActiveTuesday: [false],
            ActiveWednesday: [false],
            ActiveThursday: [false],
            ActiveFriday: [false],
            ActiveSaturday: [false],
            ActiveSunday: [false]
        });
    }

    addCondition() {
        const conditionForm = this.createConditionForm();
        this.conditions.push(conditionForm);
    }

    removeCondition(index: number) {
        this.conditions.removeAt(index);
    }

    addChildGroup() {
        this.childGroups.push(this.createConditionGroupForm());
    }

    removeChildGroup(index: number) {
        this.childGroups.removeAt(index);
    }

    onConditionTypeChange(index: number) {
        const condition = this.conditions.at(index);
        const className = condition.get('ClassName')?.value;
        
        // Reset all fields
        condition.patchValue({
            TargetThresholdProperty: '',
            TargetThresholdOperator: '=',
            Value: '',
            Time: null,
            Operator: '=',
            ActiveMonday: false,
            ActiveTuesday: false,
            ActiveWednesday: false,
            ActiveThursday: false,
            ActiveFriday: false,
            ActiveSaturday: false,
            ActiveSunday: false
        });

        // If the condition has an Id, disable the ClassName control
        if (condition.get('Id')?.value) {
            condition.get('ClassName')?.disable();
        }
    }

    getFormGroup(control: AbstractControl): FormGroup {
        return control as FormGroup;
    }
} 
